import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, ComputedRef } from 'vue';
import { useCheckout } from '@/storecontext/checkout/useCheckout';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import BasketDeliverableDialog from '@/storecontext/basket/ui/BasketDeliverableDialog.vue';
import CheckoutPaymentSettings from '@/storecontext/checkout/ui/payment/CheckoutPaymentSettings.vue';
import CheckoutPaymentItemsOutOfStock from '@/storecontext/checkout/ui/payment/CheckoutPaymentItemsOutOfStock.vue';
import CheckoutPaymentDeliveryDateChanged from '@/storecontext/checkout/ui/payment/CheckoutPaymentDeliveryDateChanged.vue';
import CheckoutPaymentBankTransfer from '@/storecontext/checkout/ui/payment/CheckoutPaymentBankTransfer.vue';
import dictionaryService from '@/core/dictionary/dictionary.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentReady',
  setup(__props) {

const labels = useBlockLabels();
const { isPaymentReady, itemIdsOutOfStock, setIsPaymentReady, showBankTransferPaymentDialog, hasDeliveryDateChanged } = useCheckout();

const hasItemsOutOfStock = computed<boolean>(() => itemIdsOutOfStock.value.length > 0);
const hasDeliveryDateChangedComputed = computed<boolean>(() => hasDeliveryDateChanged.value);

const heading: ComputedRef<string> = computed(() => {
    if (hasItemsOutOfStock.value) {
        return dictionaryService.pluralize(itemIdsOutOfStock.value.length, labels.paymentItemsOutOfStockHeader, labels.paymentItemsOutOfStockHeaderPlural);
    } else {
        return labels.paymentSettingsHeader;
    };
});

const close = (): void => {
    setIsPaymentReady(false);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BasketDeliverableDialog, {
      "is-open": _unref(isPaymentReady),
      heading: _unref(heading),
      class: "lg:max-w-500",
      onClose: close
    }, {
      default: _withCtx(() => [
        _createVNode(_Transition, {
          name: "o-anim-fade-300",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_unref(hasItemsOutOfStock))
              ? (_openBlock(), _createBlock(CheckoutPaymentItemsOutOfStock, { key: 0 }))
              : (_unref(showBankTransferPaymentDialog))
                ? (_openBlock(), _createBlock(CheckoutPaymentBankTransfer, { key: 1 }))
                : (_openBlock(), _createBlock(CheckoutPaymentSettings, { key: 2 }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open", "heading"]),
    _createVNode(BasketDeliverableDialog, {
      "is-open": _unref(hasDeliveryDateChangedComputed),
      heading: _unref(labels).earliestDeliveryDateChangedHeader,
      class: "lg:max-w-500"
    }, {
      default: _withCtx(() => [
        _createVNode(_Transition, {
          name: "o-anim-fade-300",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _createVNode(CheckoutPaymentDeliveryDateChanged)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open", "heading"])
  ], 64))
}
}

})